define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.StockTypeDomain = void 0;
    class StockTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: StockTypeDomain.Large, value: "Large" },
                    { key: StockTypeDomain.Small, value: "Small" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[StockTypeDomain.Large] = 0;
                this.KeyIndex[StockTypeDomain.Small] = 1;
                this.ValueIndex = {};
                this.ValueIndex["Large"] = 0;
                this.ValueIndex["Small"] = 1;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.StockTypeDomain = StockTypeDomain;
    Object.defineProperty(StockTypeDomain, "Large", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "L"
    });
    Object.defineProperty(StockTypeDomain, "Small", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "S"
    });
    Object.defineProperty(StockTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
